import http from "./httpService";

const { REACT_APP_WEB_API_URL: web_api_url } = process.env;

export async function getMyStatus() {
  return await http.get(`${web_api_url}/my-status`);
}

/**
 * Reduce a /my-status response to a lookup keyed by module key:
 * `{ [module]: { total_tasks, attempted_tasks } }`.
 *
 * Items missing a `module` key (older backend) are skipped, so a
 * caller can simply check for the presence of the module key.
 */
export function reduceStatusByModule(statusItems) {
  const counts = {};

  (statusItems || []).forEach((item) => {
    if (!item || !item.module) {
      return;
    }

    counts[item.module] = {
      total_tasks: item.total_tasks,
      attempted_tasks: item.attempted_tasks,
    };
  });

  return counts;
}

/**
 * Fetch /my-status once and reduce it to `{ [module]: { total_tasks, attempted_tasks } }`.
 */
export async function getTaskCountsByModule() {
  const { data: response } = await getMyStatus();
  return reduceStatusByModule(response);
}

export default {
  getMyStatus,
  reduceStatusByModule,
  getTaskCountsByModule,
};
